import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { SessionService } from "src/app/shared/services/session.service";

@Component({
  selector: "app-reset-password-page",
  templateUrl: "./reset-password-page.component.html",
  styleUrls: ["./reset-password-page.component.scss"],
})
export class ResetPasswordPageComponent implements OnInit, OnDestroy {
  public code?: string;

  private onDestroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sessionService: SessionService
  ) {}

  /**
   * Reads the optional reset code from the reset link's "token" query parameter, and leaves the
   * page once the user logs in while on it (e.g. through the login dialog opened on top of a reset
   * link because the stored tokens were stale): the code shown here has been used or is no longer
   * needed, and this page isn't meant for logged-in users.
   */
  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.code = params["token"];
    });

    this.sessionService.onLoginStateChanged$.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      if (this.sessionService.isLoggedIn) {
        this.router.navigate(["landing"]);
      }
    });
  }

  /**
   * Cleanup subscriptions on destroy.
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /**
   * Navigates back to the login page once the password has been reset.
   */
  public resetPasswordFormSubmit(): void {
    this.router.navigate(["login"]);
  }

  /**
   * Navigates back to the login page when the user cancels the reset password flow.
   */
  public backClick(): void {
    this.router.navigate(["login"]);
  }
}
